module.exports = __webpack_public_path__ + "assets/img/g2.164ff79c.jpg";